import Vue from 'vue';

const SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);
